// extracted by mini-css-extract-plugin
var _1 = "z0SZP__grid";
var _2 = "z0SZP__tiles";
export { _1 as "grid", _2 as "tiles" }
